import React, { useState, useEffect } from 'react';
// import Container from '../../Container/Container';
import { ListItem } from '../atoms/listitem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import variables from '../atoms/variables.json';
import { TextInput } from '../atoms/textinput';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment';
import BottomButton from '../atoms/bottomButton';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import ProgressCircle from "./components/ProgressCircle"

import { DocumentWithStatusCard } from './../atoms/documentWithStatusCard';
import ToolTip from '../atoms/ToolTip';
import Checkbox from '@material-ui/core/Checkbox';
import { GetFilename, getHoldingDepositStatusData, showErrorToast, showSuccesToast } from '../helpers';
// import Movein from './../../../assets/svgIcons/OpenFlo/MoveIn.svg';
import { Otp } from '../atoms/otp';
const layoutType = getPlatformType();
import {
  CardWrapper,
  TlyfeSelector,
  LineSeperator,
  Heading,
  SubHeading,
  TlyfeButtonWrapper,
  RowContainer,
  FormContainer,
} from './style';
import { useDispatch, useSelector } from 'react-redux';
import { CardBox } from '../atoms/card';
import { Button } from '../atoms/button';
// import { tenantActions } from '_actions';
import BackComponent from '../atoms/backComponent';
import OpenFlowModal from '../atoms/modal';
import CommanModal from './commanModal';
import SaveandContinueModal from '../atoms/SaveandContinueModal';
import { Radio, RadioGroup } from '@material-ui/core';
import Container from '../atoms/Container/Container';
import drawerHoc from '../../../../components/drawerHOC/DrawerHOC';
import getPlatformType from '../../../../helpers/helpers';
import { tenantActions, alertActions } from '../../redux/tenant.actions';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import DialogButton from '@material-ui/core/Button';
import { TenantService } from '../../redux/tenant.service';
import InfowaningBox from './components/infowaningBox';
import BankAccountComponent from './components/bankAccountComp';
import InventoryCheckIn from './components/InventoryCheckIn';

function MovingIn(props) {
  const dispatch = useDispatch();
  const [flowId, setFlowId] = React.useState(null);
  const [selectedTds, setSelectedTds] = React.useState();
  const [inventoryDoc, setInventoryDoc] = React.useState([]);
  const [teanats, setTeanats] = React.useState([]);
  const [showModal, setShowModal] = React.useState('');
  const [counterValue, setCounterValue] = React.useState(0);
  const [confirmDateCheckbox, setConfirmDateCheckbox] = React.useState(false);
  const [notifyDateCheckbox, setNotifyDateCheckbox] = React.useState(false);
  const [selectedAccount, setselectedAccount] = React.useState('');
  const [accountButtonText, setAccountButtonText] = React.useState('Add Account');
  const [openAccountModal, setAccountModal] = React.useState(false);
  const [inventoryReq, setInventoryReq] = React.useState(false);
  const [checkinReq, setCheckinReq] = React.useState(false);
  const [account_id, setAccount_id] = React.useState('');
  const [newAccAdded, setNewAccAdded] = React.useState('');
  const [sortCode, setsortCode] = React.useState('');
  const [accountName, setAccountName] = React.useState('');
  const [payeeRef, setPayeeRef] = React.useState('');
  // const move_in_data = useSelector((state) => state?.tenant?.moveInData);
  const globalState = useSelector((state) => state?.tenant?.flowIdInfo);
  const [dateDepositReceived, setdateDepositReceived] = React.useState(null);
  const [offerStatus, setOfferStatus] = React.useState(0);
  const [Accounts, setAccounts] = React.useState([]);
  const [showSuccessModal, setSuccessModal] = React.useState(false);
  const [showDeleteSuccessModal, setDeleteSuccessModal] = React.useState(false);
  const [showExecutionCheckModal, setShowExecutionCheckModal] = useState(false);
  const [pendingTenant, setPendingTenant] = useState(null);


  const bankAccounts = useSelector((state) => state?.tenant?.branchBankAccounts);
  console.log('bankAccounts: 74=======', bankAccounts);

  const branches = useSelector((state) => state?.tenant?.companyBranches);

  const modalGlobalObject = useSelector((state) => state?.tenant?.flowIdInfo);
  console.log('modalGlobalObject: 79==============', modalGlobalObject);

  const move_in_data = useSelector((state) => state?.tenant?.flowIdInfo?.open_flow_move_in);
  console.log('move_in_data: 82===========', move_in_data);

  const [newAccountName, setnewAccountName] = React.useState('');
  const [newAccountSortCode, setnewAccountSortCode] = React.useState('');
  const [newAccountNumber, setnewAccountNumber] = React.useState('');
  const [selectedBranch, setselectedBranch] = React.useState('');
  const moveInMoniesLabel = modalGlobalObject?.is_renewed ? 'Renewal Payments' : 'Move in Monies';

  const [modalState, setModalState] = React.useState({
    send_to_tenant: true,
  });

  useEffect(() => {
    if (modalGlobalObject) {
      setModalState({
        send_to_tenant: modalGlobalObject.send_to_tenant,
      });
      const moveInCollection = modalGlobalObject?.move_in_money_from_lead_tenant ?? move_in_data?.collectDeposit ?? false;
      setcollectDeposit(moveInCollection);
    }
  }, [modalGlobalObject, move_in_data?.collectDeposit]);

  let initialValues = {
    total_amount: move_in_data ? move_in_data?.total_amount : '',
    holding_deposit_paid: move_in_data?.holdingDeposit?.holding_desposit_amount
      ? move_in_data?.holdingDeposit?.holding_desposit_amount
      : 'N/A',
    initial_rental_payment: move_in_data ? move_in_data?.initial_rental_payment : '',
    rental_deposit: move_in_data ? move_in_data?.rental_amount : 0,
    check_in_date: move_in_data?.monies?.checkin_date
      ? moment(move_in_data.monies?.checkin_date).format('YYYY-MM-DD')
      : null,
    inventory_check_in_date: move_in_data?.monies?.inventory_check_date
      ? moment(move_in_data.monies?.inventory_check_date).format('YYYY-MM-DD')
      : null,
  };
  const [fieldsValue, setFieldValues] = React.useState(initialValues);
  const [tdsArry, setTdsArray] = React.useState([]);

  useEffect(() => {
    if (props?.route?.params?.id) {
      setFlowId(props?.route?.params?.id);
      // dispatch(tenantActions.getMoveIn(props?.route?.params?.id));
      fetchFlows()
      dispatch(tenantActions.getBranchBankAccounts());
      dispatch(tenantActions.getCompanyBranches());
    }
  }, [props?.route?.params?.id]);
  const fetchFlows = () => {
    dispatch(tenantActions.getFlowInfo(props?.route?.params?.id));

  }
  useEffect(() => {
    dispatch(tenantActions.getTdsData());
  }, []);

  useEffect(() => {
    if (globalState?.tdsData?.schemes) {
      setTdsArray(globalState?.tdsData?.schemes);
    }
  }, [globalState?.tdsData?.schemes]);

  useEffect(() => {
    if (globalState?.moveInData?.certicicateRequests) {
      let { inventory, checkin } = globalState?.moveInData?.certicicateRequests;
      if (inventory && inventory.length) {
        setInventoryReq(inventory[0]);
      }

      if (checkin && checkin.length) {
        setCheckinReq(checkin[0]);
      }
    }
  }, [globalState?.moveInData?.certicicateRequests]);

  //set account
  useEffect(() => {
    if (move_in_data?.OpenbrixBankAccount) {
      if (bankAccounts && bankAccounts?.length) {
        let filter = bankAccounts?.filter((data, index) => selectedAccount === data?.openflow_bank_account_id);
        console.log('filter: 149==========', filter);
        if (filter?.length) {
          let data = filter[0];
          setAccount_id(data?.account_id);
          setAccountName(data?.account_name);
          setsortCode(data?.sort_code);
        }
      }
    }
  }, [selectedAccount, move_in_data?.OpenbrixBankAccount]);

  useEffect(() => {
    if (bankAccounts && bankAccounts?.length) {
      setAccounts(bankAccounts);
    }
    if (modalGlobalObject?.movein_payee_ref) {
      setPayeeRef(modalGlobalObject?.movein_payee_ref);
    }
    if (move_in_data?.OpenbrixBankAccount) {
      const selectedAccount = bankAccounts?.find((val) => {
        if (val?.openflow_bank_account_id === move_in_data.OpenbrixBankAccount?.openflow_bank_account_id) {
          return val;
        }
      });
      setselectedAccount(selectedAccount);
    }
  }, [bankAccounts, move_in_data?.OpenbrixBankAccount, modalGlobalObject?.movein_payee_ref]);

  useEffect(() => {
    setFieldValues(initialValues);

    if (move_in_data?.inventory_doc) {
      console.log("move_in_data?.inventory_doc==========", move_in_data?.inventory_doc);
      // setInventoryDoc(move_in_data?.inventory_doc);
      setInventoryDoc(move_in_data?.inventory_doc?.split(","));
    } else {
      setInventoryDoc([]);
    }

    if (move_in_data?.monies?.tds_pdf) {
      setSelectedTds(move_in_data?.monies?.tds_pdf);
    }

    // setcollectDeposit(move_in_data?.collectDeposit);

    if (modalGlobalObject?.tenants && modalGlobalObject?.tenants?.length) {
      setTeanats(modalGlobalObject?.tenants);
      let ar = modalGlobalObject?.tenants;
      let movein_money_status = 0;
      ar?.some(function (item, index) {
        if (item?.movein_money_status > 0) {
          movein_money_status = item?.movein_money_status;
          return true;
        }
      });
      setOfferStatus(movein_money_status);
    }
  }, [
    move_in_data?.total_amount,
    move_in_data?.rental,
    move_in_data?.initial_rental_payment,
    move_in_data?.holding_deposit_paid,
    move_in_data?.flow,
    move_in_data?.monies?.tds,
    // move_in_data?.monies?.inventory_documents,
    move_in_data?.collectDeposit,
    modalGlobalObject?.tenants,
    move_in_data?.inventory_doc,
  ]);

  const getCheckedStatus = () => {
    if (modalGlobalObject?.tenants && modalGlobalObject?.tenants.length) {
      let isChecked = true;
      for (let i = 0; i < modalGlobalObject?.tenants.length; i++) {
        if (modalGlobalObject?.tenants[i]?.movein_money_status != 3) {
          isChecked = false;
          break;
        }
      }
      return isChecked;
    }
    return false;
  };

  const _onAddNewBankAccount = (data) => {
    console.log("modalGlobalObject", modalGlobalObject)
    let payload = {
      "sort_code": newAccountSortCode,
      "account_id": "hub_new",
      "account_name": newAccountName,
      "branch_id": modalGlobalObject?.branch?.name,
      "branch": modalGlobalObject?.branch?.name,
      "swift_code": "",
      "iban": "",
    }

    if (newAccountSortCode && newAccountNumber && newAccountName && modalGlobalObject?.branch?.name) {
      dispatch(tenantActions.saveBankAccount(payload));
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      showErrorToast('Please select all mandatory fields')
    }
    setAccountModal(false);
  };

  const accountDetails = () => (
    <div>
      <>
        {/* <SubHeading>Choose a branch</SubHeading> */}
        {/* <Select
          value={selectedBranch}
          style={{ width: layoutType == 'phone' ? '100%' : '50%', height: '40px', borderWidth: 0 }}
          onChange={(e) => {
            setselectedBranch(e.target.value);
            // setnewAccountName(selectedAc.account_name);
            // setnewAccountSortCode(selectedAc.account_id);
            // setnewAccountNumber(selectedAc.sort_code);
            // setAccountButtonText('Update Account');
          }}
          variant="outlined"
          name="selectedBranch"
          placeholder="duration"
        >
          {branches?.map((data, i) => {
            return (
              <MenuItem value={data} key={'mi' + i}>
                {data?.name}
              </MenuItem>
            );
          })}
        </Select> */}
        <RowContainer>
          <FormContainer>
            <TextInput
              title={'Account Name'}
              value={newAccountName}
              containerStyles={{ width: '100%' }}
              onChange={(e) => setnewAccountName(e.target.value)}
            />
          </FormContainer>
        </RowContainer>
        <RowContainer>
          <FormContainer>
            <Otp
              title={'Sort Code'}
              no={6}
              value={newAccountSortCode}
              containerStyles={{ width: '100%' }}
              onChange={(e) => setnewAccountSortCode(e.target.value)}
            />
          </FormContainer>
          <FormContainer>
            <Otp
              value={newAccountNumber}
              title={'Account Number'}
              no={8}
              containerStyles={{ width: '100%' }}
              onChange={(e) => setnewAccountNumber(e.target.value)}
            />
          </FormContainer>
        </RowContainer>
      </>
      <RowContainer
        style={{
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
          marginTop: 10,
        }}
      >
        <Button
          onClick={() => {
            // _onSave(false, false);
            _onAddNewBankAccount()
            setAccountButtonText('Update Account');
          }}
          style={{
            marginTop: '10px',
            borderColor: variables.purple1,
          }}
          title={accountButtonText}
          type="stripe"
        />
      </RowContainer>
    </div>
  );

  const _confirmReceiptAll = () => {
    // let arr = [];
    // teanats.forEach((data) => {
    //   arr.push({
    //     ...data,
    //     movein_money_status: 3,
    //     movein_money_received_date: data.movein_money_received_date ? data.movein_money_received_date : new Date(),
    //   });
    // });
    // _confirmReceipt({ tenants: arr });
    let arr = [];
    modalGlobalObject?.tenants?.forEach((data) => {
      arr.push(data?.open_flow_sub_tenant_id);
    });

    _confirmReceipt({ flow_id: flowId, open_flow_sub_tenant_id: arr });
  };

  const _confirmReceipt = (data) => {
    dispatch(tenantActions.confirmMovin(data, flowId));
  };

  const _requestMoveInMonies = (data) => {
    dispatch(tenantActions.requestMoveInMonies(data, flowId));
  };

  const requestAllMoveInMoniesEntry = (tenant) => {
    if (!modalGlobalObject?.is_agreement_fully_executed) {
      setPendingTenant(tenant);
      setShowExecutionCheckModal(true);
      return;
    }
    setSuccessModal(true);
  };

  const _onMovinData = (DATAAA) => {
    let data = {
      inventory_check_date: fieldsValue?.inventory_check_in_date,
      checkin_date: fieldsValue?.check_in_date,
      inventory_id: null,
      deposit_schema: [selectedTds],
      payee_ref: payeeRef,
      account: {
        account_id: DATAAA?.account?.account_id,
        sort_code: DATAAA?.account?.sort_code,
        account_name: DATAAA?.account?.account_name,
      },
      inventory: {
        inventory_documents: inventoryDoc,
      },
      collectDeposit: collectDeposit,
    };

    let payload = {
      "flow_id": flowId,
      payee_ref: DATAAA?.payeeRef,
      move_in_money_from_lead_tenant: collectDeposit,
      openflow_bank_account_id: DATAAA?.account?.openflow_bank_account_id,
    };

    dispatch(tenantActions.saveMoveinData(payload, flowId, modalGlobalObject?.is_renewed));
    setAccountModal(false);
  };



  // const _onAddRentalData = (url) => {
  //   dispatch(
  //     tenantActions.addRentalOffer(
  //       {
  //         account: {
  //           account_id: account_id,
  //           sort_code: sortCode,
  //           account_name: accountName,
  //         },
  //         payee_ref: payeeRef,
  //       },
  //       flowId,
  //       url,
  //       true
  //     )
  //   );
  // };
  const _onArrangeCheckIn = () => {
    let data = {
      check_in_date: fieldsValue.check_in_date,
      inventory_check_in_date: fieldsValue.inventory_check_in_date,
      additional_areas: counterValue,
      key_drop_off: fieldsValue.key_drop_off,
      key_pick_up: fieldsValue.key_pick_up,
      notes: fieldsValue.notes,
      notifyDateCheckbox: notifyDateCheckbox,
      confirmDateCheckbox: confirmDateCheckbox,
    };
    // dispatch(tenantActions.arrangeCheckIn(data, flowId));
    setShowModal(false);
  };

  const addDoc = (data) => {
    const documents = inventoryDoc;
    documents.push(data[0])
    setInventoryDoc(documents);

    dispatch(tenantActions.uploadInventoryDocuments({ flow_id: flowId, inventory_documents: documents?.toString(), deleted_document: null }));
  };

  const removeDoc = (index) => {
    setDeleteSuccessModal({ value: index, show: true })
  };

  const renderModal = () => (
    <CommanModal
      onSubmitted={() => setShowModal(false)}
      type={'inventory'}
      initialCost={65}
      minRange={1}
      flowID={flowId}
    />
  );

  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  };

  const [collectDeposit, setcollectDeposit] = React.useState(false);
  console.log("collectDeposit", collectDeposit)
  const ccyFormat = (num) => {
    return `£ ${num.toFixed(2)}`
  }

  const getInitialRentalAmount = () => {
    if (modalGlobalObject.open_flow_rental_offer && modalGlobalObject.open_flow_rental_offer?.initial_rental_amount) {
      return modalGlobalObject.open_flow_rental_offer?.initial_rental_amount;
    } else {
      return 0
    }
  }

  const getTenancyDepositAmount = () => {
    if (modalGlobalObject.open_flow_rental_offer && modalGlobalObject.open_flow_rental_offer?.tenancy_deposit_amount) {
      return modalGlobalObject.open_flow_rental_offer?.tenancy_deposit_amount;
    } else {
      return 0
    }
  }

  const getHoldingDeposit = () => {
    if (modalGlobalObject.open_flow_holding_deposit && modalGlobalObject.open_flow_holding_deposit?.holding_desposit_amount && modalGlobalObject.open_flow_holding_deposit?.is_holding_deposit_selected) {
      return modalGlobalObject.open_flow_holding_deposit.holding_desposit_amount;
    } else {
      return 0
    }
  }

  const getTotalAmount = () => {
    return getInitialRentalAmount() + getTenancyDepositAmount() - getHoldingDeposit()
  }

  const getMoveInMoney = (tenant) => {
    const total = getTotalAmount();
    if (modalGlobalObject?.move_in_money_from_lead_tenant) {
      if (tenant?.is_lead) {
        return ccyFormat(total);
      } else {
        return ccyFormat(0);
      }
    } else {
      return ccyFormat(total / modalGlobalObject?.tenants?.length)
    }
  }
  const isAlreadyRequested = () => {

    const tenants1 = modalGlobalObject?.tenants.filter((tenant) => tenant.movein_money_status == 0);

    return tenants1.length !== modalGlobalObject?.tenants?.length;
  }
  return (
    <Container>
      <CardWrapper>
        <ProgressCircle props={props} />
        {/* <ListItem
          type={'complete'}
          title={'Moving In'}
          description={`A breakdown of all "Moving in" Monies, including the prescribed information and relevant requirements of the  tenant's deposit.`}
          showPropertyCard
          // icon={Movein}
        />

        <BackComponent
          id={flowId}
          isComplete={move_in_data?.flow?.move_in_status === 1 ? true : false}
          flowtype={'move_in_status'}
        /> */}
        <BackComponent
          id={flowId}
          isComplete={modalGlobalObject?.move_in_status === 1 ? true : false}
          flowtype="move_in_status"
        />
        <React.Fragment>
          {/* <SubHeading>Deposit & Rent</SubHeading>
          <CardBox hasBorderRadius={true} backColor={variables.powderBlue}>
            <SubHeading>Deposit & upfront rental payment</SubHeading>
            <SubHeading color={variables.scooter}>
              The Deposit demand is auto-calculated to a sum equal to 5 weeks rent. Demand for this payment together
              with the "Initial" first rental payment will be sent to the Applicant Tenant.
            </SubHeading>
          </CardBox>
          <LineSeperator /> */}
          <SubHeading>{moveInMoniesLabel}</SubHeading>
          <CardBox hasShadow hasBorderRadius style={{ position: 'relative', width: '100%' }}>
            <ToolTip
              style={{ top: '0%', right: '-29%' }}
              heading={`${moveInMoniesLabel} Collection`}
              ContentData={[
                `TIP 1`,
                `${moveInMoniesLabel} is usually collected from only the Lead tenant`,
                'TIP 2',
                `For APT tenancies, the Tenant Fee Act stipulates that you may take a MAXIMUM of one weeks rent for ${moveInMoniesLabel}`,
              ]}
            />
            <SubHeading>
              There are two methods to collect the {moveInMoniesLabel}. <br />
              <br />
              You can either collect it:
              <br />
              1) ONE single amount from the lead tenant <br />
              2) Equal amounts, split between all tenants
              <br /> <br />
              How would you like to collect the {moveInMoniesLabel}?
            </SubHeading>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="move_in_money_from_lead_tenant"
                name="move_in_money_from_lead_tenant"
                value={collectDeposit}
                onChange={(e) => {
                  if (e?.target?.value === 'true') {
                    setcollectDeposit(true);
                  } else {
                    setcollectDeposit(false);
                  }
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <FormControlLabel
                    value={true}
                    control={<Radio style={{ color: variables.heliotrope }} />}
                    style={{ color: 'black' }}
                    label="All from lead tenant"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio style={{ color: variables.heliotrope }} />}
                    style={{ color: 'black' }}
                    label="Equally between all tenants"
                  />
                </div>
              </RadioGroup>
            </FormControl>
          </CardBox>
          <CardBox style={{ position: 'relative', marginTop: 20, width: '100%' }} hasBorderRadius hasShadow>
            <ToolTip
              style={{ top: '20%', right: '-29%' }}
              heading={'Tooltip'}
              ContentData={[
                `Check that the "${moveInMoniesLabel}" are correct and send a breakdown and demand to the Applicant Tenant.`,
                `Sometimes an "initial 1st rental payment" may be larger or smaller than the agreed monthly rent.`,
              ]}
            />

            <SubHeading color={variables.scooter}> Breakdown </SubHeading>

            <TextInput
              title={'Tenancy Deposit'}
              inputProps={{ readOnly: true, style: { textAlign: 'right', paddingRight: '12px', fontSize: '15px', fontWeight: '600', color: '#1D2939' } }}
              value={ccyFormat(getTenancyDepositAmount())}
              wrapperstyle={{
                display: 'flex',
                marginTop: '15px',
                width: layoutType != 'phone' ? '70%' : '100%',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
              containerstyles={{ width: layoutType === 'phone' ? '130px' : '180px', borderRadius: '8px', flexShrink: 0 }}
              borderBox="1px solid #D0D5DD"
              inputTextStyle={{ fontSize: 14, fontWeight: '600', color: '#344054', margin: 0, fontFamily: 'lato' }}
            />


            <TextInput
              title={'Initial Rental Payment'}
              value={ccyFormat(getInitialRentalAmount())}
              inputProps={{ readOnly: true, style: { textAlign: 'right', paddingRight: '12px', fontSize: '15px', fontWeight: '600', color: '#1D2939' } }}
              wrapperstyle={{
                display: 'flex',
                marginTop: '15px',
                width: layoutType != 'phone' ? '70%' : '100%',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
              containerstyles={{ width: layoutType === 'phone' ? '130px' : '180px', borderRadius: '8px', flexShrink: 0 }}
              borderBox="1px solid #D0D5DD"
              inputTextStyle={{ fontSize: 14, fontWeight: '600', color: '#344054', margin: 0, fontFamily: 'lato' }}
            />

            <TextInput
              title={'SubTotal'}
              value={ccyFormat(getInitialRentalAmount() + getTenancyDepositAmount())}
              inputProps={{ readOnly: true, style: { textAlign: 'right', paddingRight: '12px', fontSize: '15px', fontWeight: '600', color: '#1D2939' } }}
              wrapperstyle={{
                display: 'flex',
                marginTop: '15px',
                width: layoutType != 'phone' ? '70%' : '100%',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
              containerstyles={{ width: layoutType === 'phone' ? '130px' : '180px', borderRadius: '8px', flexShrink: 0 }}
              borderBox="1px solid #D0D5DD"
              inputTextStyle={{ fontSize: 14, fontWeight: '600', color: '#344054', margin: 0, fontFamily: 'lato' }}
            />

            <TextInput
              title={'Holding Deposit Paid'}
              inputProps={{ readOnly: true, style: { textAlign: 'right', paddingRight: '12px', fontSize: '15px', fontWeight: '600', color: '#1D2939' } }}
              value={`- ${ccyFormat(getHoldingDeposit())}`}
              wrapperstyle={{
                display: 'flex',
                width: layoutType != 'phone' ? '70%' : '100%',
                alignItems: 'center',
                marginTop: '15px',
                justifyContent: 'space-between',
              }}
              containerstyles={{ width: layoutType === 'phone' ? '130px' : '180px', borderRadius: '8px', flexShrink: 0 }}
              borderBox="1px solid #D0D5DD"
              inputTextStyle={{ fontSize: 14, fontWeight: '600', color: '#344054', margin: 0, fontFamily: 'lato' }}
            />

            <TextInput
              title={`Total Amount - ${moveInMoniesLabel}`}
              inputProps={{ readOnly: true, style: { textAlign: 'right', paddingRight: '12px', fontSize: '15px', fontWeight: '600', color: '#1D2939' } }}
              value={ccyFormat(getTotalAmount())}
              wrapperstyle={{
                display: 'flex',
                width: layoutType != 'phone' ? '70%' : '100%',
                alignItems: 'center',
                marginTop: '15px',
                justifyContent: 'space-between',
              }}
              containerstyles={{ width: layoutType === 'phone' ? '130px' : '180px', borderRadius: '8px', flexShrink: 0 }}
              borderBox="1px solid #D0D5DD"
              inputTextStyle={{ fontSize: 14, fontWeight: '600', color: '#344054', margin: 0, fontFamily: 'lato' }}
            />
            <BankAccountComponent
              dataa={{
                payeeRef: payeeRef,
                account: selectedAccount
              }}
              onSave={(data) => {
                console.log("Received in parent:", data);
                _onMovinData(data)
              }}
            />

          </CardBox>

          {move_in_data?.openflow_bank_account_id ?
            (
              <>
                <LineSeperator />

                {modalGlobalObject?.tenants && modalGlobalObject?.tenants?.length ? (
                  <>
                    <TlyfeSelector style={{ marginTop: 0, justifyContent: 'space-between' }}>
                      <div
                        style={{
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        <Heading>Receiving {moveInMoniesLabel}</Heading>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <FormControl component="fieldset">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={getCheckedStatus()}
                                style={{ color: variables.heliotrope }}
                                onChange={() => _confirmReceiptAll()}
                                name="isReferencingComplete"
                              />
                            }
                            label="Confirm All"
                            style={{ color: '#000', fontSize: 10 }}
                          />
                        </FormControl>
                      </div>
                    </TlyfeSelector>
                    <BottomButton
                      buttonText={isAlreadyRequested() ? "Request Again From All" : ' Request From All'}
                      onRightClick={() => {
                        requestAllMoveInMoniesEntry(null)
                      }
                      }
                    />
                    {modalGlobalObject?.tenants?.map((data, index) => {
                      return (
                        <>
                          <CardBox style={{ marginBottom: '5%' }} hasShadow hasBorderRadius>
                            <RowContainer>
                              <div
                                style={{
                                  flex: 0.7,
                                  paddingRight: '10%',
                                  paddingLeft: '4%',
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <CardBox
                                  style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                  }}
                                  hasBorderRadius
                                  backColor={getHoldingDepositStatusData(data?.movein_money_status).backgroundColor}
                                  borderColor={getHoldingDepositStatusData(data?.movein_money_status).borderColor}
                                >
                                  <SubHeading style={{ margin: 0 }}>
                                    {data?.app_user?.user?.first_name + ' ' + data?.app_user?.user?.last_name}
                                  </SubHeading>

                                  <SubHeading
                                    style={{
                                      margin: 0,
                                      color: getHoldingDepositStatusData(data?.movein_money_status).color,
                                    }}
                                  >
                                    {getHoldingDepositStatusData(data?.movein_money_status).DateText}{' '}
                                    {getHoldingDepositStatusData(data?.movein_money_status, data).Date
                                      ? moment(getHoldingDepositStatusData(data?.movein_money_status, data).Date).format(
                                          'YYYY/MM/DD'
                                        )
                                      : 'N/A'}
                                  </SubHeading>

                                  <SubHeading
                                    style={{
                                      margin: 0,
                                      color: getHoldingDepositStatusData(data?.movein_money_status).color,
                                    }}
                                  >
                                    {getHoldingDepositStatusData(data?.movein_money_status).Text}
                                  </SubHeading>
                                </CardBox>
                              </div>
                              <div style={{ flex: 0.3 }}></div>
                            </RowContainer>
                            <RowContainer>
                              <div
                                style={{
                                  flex: 0.7,
                                  paddingRight: '10%',
                                  paddingLeft: '4%',
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <TextInput
                                  disabled={true}
                                  value={getMoveInMoney(data)}
                                  title={'Amount (£)'}
                                  containerstyles={{ width: '100%' }}
                                />
                              </div>
                              <div
                                style={{
                                  flex: 0.7,
                                  paddingRight: '10%',
                                  paddingLeft: '4%',
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              ></div>
                              <div
                                style={{
                                  flex: 0.3,
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                <TlyfeButtonWrapper>
                                  <Button
                                    onClick={() =>
                                      data?.movein_money_status != 3 ?
                                        _confirmReceipt({
                                          flow_id: data?.openflow_id,
                                          open_flow_sub_tenant_id: [data?.open_flow_sub_tenant_id],
                                        })
                                        :
                                        requestAllMoveInMoniesEntry(data)
                                    }
                                    style={{
                                      marginTop: '15px',
                                      backgroundColor:
                                        data.movein_money_status != 3 ? 'transparent' : variables.puregreen,
                                    }}
                                    title={data.movein_money_status != 3 ? 'Confirm Receipt' : 'Revoke Confirmation'}
                                    color={data.movein_money_status != 3 ? variables.puregreen : variables.peachgreen}
                                    textColor={'#000'}
                                    type={data.movein_money_status != 3 ? 'custom' : 'solid'}
                                  />
                                </TlyfeButtonWrapper>
                              </div>
                              {/*
                             */}
                            </RowContainer>
                          </CardBox>
                        </>
                      );
                    })}
                  </>
                ) : null}
              </>
            )
            : null}
          <LineSeperator />


          <InventoryCheckIn
            flowId={flowId}
            openFlow={modalGlobalObject}
          />
          {/* <LineSeperator />
          <CardBox hasBorderRadius hasShadow style={{ width: '100%' }}>
            <SubHeading style={{ fontSize: '13px' }}>
              <strong>Tenancy Deposit Scheme Information</strong>
              <br />
              <br />
              Please select the TDS scheme you will be using to protect this deposit and upload any additional
              information document you wish to share with your tenant(s).
              <br />
              <br />
              Your tenants will be sent this document for their information.
              <br />
              <br />
              Please select the deposit scheme you will use to protect this deposit
              <br />
              <br />
            </SubHeading>
            <div
              style={{
                display: 'flex',
                marginTop: '20px',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '80%',
              }}
            >
              <SubHeading style={{ fontSize: '14px' }}>Your TDS Scheme-</SubHeading>
              <Select
                value={selectedTds ? selectedTds : ''}
                style={{ width: '80%', borderWidth: 0, height: '42px' }}
                onChange={(e) => setSelectedTds(e.target.value)}
                variant="outlined"
                name="rental_type"
                placeholder="duration"
              >
                {tdsArry.map((data, i) => (
                  <MenuItem value={data?.file} key={'tdsmi' + i}>
                    {data.name}
                  </MenuItem>
                ))}
              </Select>
            </div>
            {selectedTds ? (
              <CardBox
                hasShadow={true}
                hasBorderRadius={true}
                style={{
                  background: variables.lightGreen,
                  paddingTop: 5,
                  paddingBottom: 5,
                  paddingRight: 15,
                  paddingLeft: 15,
                  marginBottom: '5%',
                  width: '50%',
                  marginTop: '5%',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ fontSize: '14px', width: 200 }}>{GetFilename(selectedTds) || 'file'}</div>
                  <a target="_blank" href={selectedTds}>
                    <span
                      style={{
                        fontSize: '14px',
                        fontWeight: 500,
                        color: variables.purple1,
                      }}
                    >
                      View
                    </span>
                  </a>
                </div>
              </CardBox>
            ) : null}
          </CardBox> */}

          <div>
            <Dialog
              open={showSuccessModal}
              onClose={() => {
                setSuccessModal(false)
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">Are you sure?</DialogTitle>


              <DialogContent>
                <DialogContentText sx={{ marginBottom: 10 }}>
                  Are you sure, You want to request payment?.
                </DialogContentText>

              </DialogContent>

              <DialogActions>
                <DialogButton onClick={() => {
                  let tenantsToRequest = []
                  if (pendingTenant?.open_flow_sub_tenant_id) {
                    tenantsToRequest = [pendingTenant.open_flow_sub_tenant_id]
                  } else {
                    tenantsToRequest = modalGlobalObject.tenants.map((tenant) => tenant.open_flow_sub_tenant_id)
                  }

                  TenantService.requestMoveInMonies({
                    flow_id: flowId,
                    open_flow_sub_tenant_id: tenantsToRequest
                  }).then((response) => {
                    console.log("sendRentalOffer,", response)
                    setSuccessModal(false)
                    setPendingTenant(null)
                    showSuccesToast("Offer Requested to all Tenants!")
                    fetchFlows()
                  });


                }} color="primary">
                  Ok
                </DialogButton>
                <DialogButton onClick={() => {
                  setSuccessModal(false)
                  setPendingTenant(null)
                }} color="secondary">
                  Cancel
                </DialogButton>
              </DialogActions>
            </Dialog>
          </div>
          <div>
            <Dialog
              open={showExecutionCheckModal}
              onClose={() => setShowExecutionCheckModal(false)}
              aria-labelledby="execution-check-title"
              aria-describedby="execution-check-description"
            >
              <DialogTitle id="execution-check-title" style={{ color: '#265D8C', fontWeight: 700 }}>
                Is the tenancy agreement fully executed?
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="execution-check-description" style={{ color: 'text.secondary', marginBottom: 20 }}>
                  To comply with the new legislation you must have a fully executed tenancy agreement before requesting any move in monies.
                </DialogContentText>
                <DialogContentText style={{ fontWeight: 600, color: '#555' }}>
                  Do you confirm you have a fully executed tenancy agreement?
                </DialogContentText>
              </DialogContent>
              <DialogActions style={{ justifyContent: 'center', paddingBottom: 20 }}>
                <DialogButton
                  onClick={() => setShowExecutionCheckModal(false)}
                  color="secondary"
                  variant="outlined"
                  style={{ textTransform: 'none', fontWeight: 600, borderRadius: 8, paddingLeft: 30, paddingRight: 30 }}
                >
                  CANCEL
                </DialogButton>
                <DialogButton
                  onClick={() => {
                    setShowExecutionCheckModal(false);
                    setSuccessModal(true);
                  }}
                  color="primary"
                  variant="contained"
                  style={{
                    textTransform: 'none',
                    fontWeight: 600,
                    borderRadius: 8,
                    paddingLeft: 40,
                    paddingRight: 40,
                    background: 'linear-gradient(90deg, #A679D2 0%, #8BA9E4 100%)',
                    color: 'white'
                  }}
                >
                  YES
                </DialogButton>
              </DialogActions>
            </Dialog>
          </div>

        </React.Fragment>
      </CardWrapper>
      {showModal && (
        <OpenFlowModal
          showModal={showModal}
          setShowModal={setShowModal}
          modalBody={renderModal()}
          showFooter={false}
          modalHeading={'Inventory & Check in'}
          modalWidth={600}
        />
      )}
      {openAccountModal && (
        <OpenFlowModal
          showModal={openAccountModal}
          setShowModal={setAccountModal}
          modalBody={accountDetails()}
          showFooter={false}
          modalHeading=""
          modalWidth={600}
        />
      )}
    </Container>
  );
}
export default drawerHoc({
  Component: MovingIn,
  showBackButton: true,
  backNavigation: "CurrentOnboards"
});
